import * as React from "react";
import { Section } from "../../common/section/Section.tsx";
import { useQuery } from "convex-helpers/react/cache/hooks";
import { api } from "@repo/convex/convex/_generated/api";
import { useDebounce } from "../../common/hooks.ts";
import { useMutation } from "convex/react";
import { toast } from "sonner";
import { useEffect } from "react";
import { UserProfileStatusBadge } from "./UserProfileStatusBadge.tsx";
import { TokenUsageTable } from "./TokenUsageTable.tsx";
import { QueuedUpdatesList } from "./QueuedUpdatesList.tsx";

interface Props {}

export const MyProfileSection: React.FC<Props> = ({}) => {
  const profileDoc = useQuery(api.userProfiles.findMine, {});
  const [profile, setProfile] = React.useState<string | null>(null);
  const [isSending, setIsSending] = React.useState(false);
  const updateMyProfile = useMutation(api.userProfiles.updateMyProfile);

  useEffect(() => {
    if (isSending) return;
    setProfile(profileDoc?.profile ?? null);
  }, [profileDoc, isSending]);

  const _updateProfile = useDebounce((profile: string) => {
    console.log("updating profile..");
    setIsSending(true);
    updateMyProfile({ profile })
      .catch(toast.error)
      .finally(() => setIsSending(false));
  }, 500);

  return (
    <>
      <Section
        title={"What the AI knows about you"}
        description={
          "Your profile, built up from what you archive. Edit it as you like; chat and the other AI bits read it."
        }
        titleRight={profileDoc ? <UserProfileStatusBadge profile={profileDoc} /> : undefined}
      >
        <textarea
          className="settings-profile"
          value={profile ?? ""}
          placeholder="Nothing yet. It fills in as you archive things."
          aria-label="Your profile"
          onChange={(e) => {
            _updateProfile(e.target.value);
            setProfile(e.target.value);
          }}
        />
        {profileDoc && <TokenUsageTable profileDoc={profileDoc} />}
      </Section>

      {profileDoc && (
        <Section title="Queued updates" description="Archived things waiting to update your profile.">
          <QueuedUpdatesList />
        </Section>
      )}
    </>
  );
};
